import { AppointmentAdvancePayment } from '@dreryk/egabinet-appointment-advance-payment-frontend-api';
import { AppointmentDetails } from '@dreryk/egabinet-appointment-frontend-api';

import { Notification, NotificationSize, NotificationType, StyledFlex } from '@dreryk/react-components';

import {
   AppointmentBeginDateTextView,
   AppointmentPatientTextView,
   AppointmentPractitionerTextView,
} from '~libs.desktop.shared.appointment';

import { AdvancePaymentPaidAmountTextView } from '../../../components/AdvancePaymentPaidAmountTextView';
import { AdvancePaymentPendingOnlinePaymentsTotalAmountTextView } from '../../../components/AdvancePaymentPendingOnlinePaymentsTotalAmountTextView';
import { AdvancePaymentRefundsTotalAmountTextView } from '../../../components/AdvancePaymentRefundsTotalAmountTextView';
import { AdvancePaymentRequiredAmountTextView } from '../../../components/AdvancePaymentRequiredAmountTextView';
import { translationKeys } from '../../../translations';
import { AdvancePaymentMethodTypeTextView } from '../../../components/AdvancePaymentMethodTypeTextView';
import { AdvancePaymentRefundToBeCreatedTypeTextView } from '../../../components/AdvancePaymentRefundToBeCreatedTypeTextView';
import { AdvancePaymentRefundToBeCreatedAmountTextView } from '../../../components/AdvancePaymentRefundToBeCreatedAmountTextView';

import { OneColumnSpan, ThreeColumnsGrid, TwoColumnsGrid } from './AdvancePaymentOverpaymentView.styled';

type AdvancePaymentOverpaymentViewProps = {
   appointmentDetails: AppointmentDetails;
   advancePayment: AppointmentAdvancePayment;
};

export const AdvancePaymentOverpaymentView = (props: AdvancePaymentOverpaymentViewProps): JSX.Element => {
   return (
      <StyledFlex direction={'column'} gap={'20px'}>
         <TwoColumnsGrid>
            <AppointmentBeginDateTextView beginDate={props.appointmentDetails.beginDate} />
            <AppointmentPatientTextView patient={props.appointmentDetails.patient} />

            <OneColumnSpan>
               <AppointmentPractitionerTextView practitioner={props.appointmentDetails.practitioner} />
            </OneColumnSpan>

            <AdvancePaymentRequiredAmountTextView requiredAmount={props.advancePayment.requiredAmount} />
            <AdvancePaymentPaidAmountTextView
               paidAmount={props.advancePayment.paidAmount}
               requiredAmount={props.advancePayment.requiredAmount}
            />

            <AdvancePaymentPendingOnlinePaymentsTotalAmountTextView
               pendingOnlinePaymentsTotalAmount={props.advancePayment.pendingOnlinePaymentsTotalAmount}
            />
            <AdvancePaymentRefundsTotalAmountTextView refundsTotalAmount={props.advancePayment.refundsTotalAmount} />
         </TwoColumnsGrid>

         <ThreeColumnsGrid>
            <AdvancePaymentMethodTypeTextView paymentMethodType={props.advancePayment.paymentMethod} />
            <AdvancePaymentRefundToBeCreatedTypeTextView
               refundToBeCreatedMethodType={props.advancePayment.refundToBeCreatedMethod}
            />
            <AdvancePaymentRefundToBeCreatedAmountTextView
               refundToBeCreatedAmount={props.advancePayment.refundToBeCreatedAmount}
            />
         </ThreeColumnsGrid>

         <OneColumnSpan>
            <Notification
               testId={'overpaymentRefundedAutomatically'}
               label={translationKeys.overpaymentRefundedAutomatically}
               type={NotificationType.INFO}
               size={NotificationSize.SMALLER}
            />
         </OneColumnSpan>
      </StyledFlex>
   );
};
